import { useQuery } from '@tanstack/react-query';

import { fetchCompaniesStatistics } from '@/api/v4/snapshot-funnel.api';
import { QueryKey } from '@/config/query-client';

export const useCompaniesStatistics = () => {
  return useQuery({
    queryKey: [QueryKey.CompaniesStatistics],
    queryFn: fetchCompaniesStatistics,
    staleTime: 1000 * 60 * 5,
  });
};
